const dishes = [
    {
        id : 1,
        title : 'roastChicken',
        description: 'roastChickenDesc',
        badge: '',
        image: 'assets/img/services/restaurant/menu/1.jpg',
        category: 'main-course'
    },
    {
        id : 2,
        title : 'grilledChicken',
        description: 'grilledChickenDesc',
        badge: '',
        image: 'assets/img/services/restaurant/menu/2.jpg',
        category: 'main-course'
    },
    {
        id : 3,
        title : 'grilledPork',
        description: 'grilledPorkDesc',
        badge: 'Popular',
        image: 'assets/img/services/restaurant/menu/3.jpg',
        category: 'main-course'
    },
    {
        id : 4,
        title : 'localDrinks',
        description: 'localDrinksDesc',
        badge: '',
        image: 'assets/img/services/restaurant/menu/4.jpg',
        category: 'drink'
    },
    {
        id : 5,
        title : 'suya',
        description: 'suyaDesc',
        badge: '',
        image: 'assets/img/services/restaurant/menu/5.jpg',
        category: 'main-course'
    },
    {
        id : 6,
        title : 'whisky',
        description: 'whiskyDesc',
        badge: '',
        image: 'assets/img/services/restaurant/menu/6.jpg',
        category: 'drink'
    }
]

export default dishes